// extracted by mini-css-extract-plugin
module.exports = {"textArea":"_1srvIxvc"};